import { createContext } from 'react';
import MerchantOrder from '../../../interfaces/MerchantOrder';
import MerchantPreOrder from '../../../interfaces/MerchantPreOrder';
import { PublicForm } from '../../../redux/PublicFormSlice/PublicFormSlice';
import { RemoteData, RemoteStatus } from '../../../redux/SharedTypes';

export default createContext<{
	form: PublicForm;
	updateForm: (value: Partial<PublicForm>) => void;
	action: RemoteData<MerchantPreOrder | MerchantOrder>;
	setAction: (value: RemoteData<MerchantPreOrder | MerchantOrder>) => void;
}>({
	form: {
		orderId: null,
		description: null,
		receiveAmount: '',
		receiveCurrencyCode: null,
	},
	updateForm: () => {},
	action: { status: RemoteStatus.None },
	setAction: () => {},
});
